// Check changes — the dialog shared by the Master Sheet and SAP Ship Doc (ChangeCheckDialog.jsx), in the portal's
// four languages (2026-10-21). {{noun}} is the screen's own word for what it compares ("sheet" / "document"),
// passed in already translated by MasterSheetChanges.jsx and 36_SapShipDoc.jsx.
const en = {
  title: 'Changes since your last check',
  comparing: 'Comparing the {{noun}} now ({{now}} rows) with the {{noun}} you marked as checked on <b>{{at}}</b> ({{then}} rows)',
  intro: 'Every new row, every row gone and every cell that moved, old value beside new',
  close: 'Close',
  firstTitle: 'This is your first check',
  firstBody: 'There is nothing to compare with yet. Save the {{noun}} as it stands now ({{n}} rows) as your starting point — from then on, Check changes lists everything that moved after it, whoever or whatever moved it.',
  chipChanged: 'Changed',
  chipNew: 'New',
  chipGone: 'Gone',
  rows_one: '{{n}} row',
  rows_other: '{{n}} rows',
  wordChanged: 'Changed',
  wordAdded: 'New row',
  wordRemoved: 'Row gone',
  nothingChanged: 'Nothing on the {{noun}} has changed since {{at}}.',
  cellsByColumn: 'Cells changed by column:',
  searchAria: 'Search the changes',
  clear: 'Clear',
  countOf: '{{shown}} of {{total}} rows',
  truncated: 'The list shows the first {{shown}} of {{total}} changed rows. Export Excel carries all of them.',
  colChange: 'Change',
  colWhat: 'What changed',
  colWhere: 'Where from',
  showMore: 'Show {{n}} more',
  compareWith: 'Compare with',
  myLastCheck: 'my last check — {{at}}',
  earlierCheck: 'an earlier check — {{at}}',
  checkAgain: 'Check again',
  building: 'Building…',
  exportExcel: 'Export Excel',
  markHint: 'What you see now becomes your starting point for the next check',
  marked: 'Marked as checked',
  mark: 'Mark as checked',
  savedShort: 'Saved',
  saveStart: 'Save as my starting point',
  savedNext: 'Saved. Your next check will compare against the {{noun}} as of {{at}}.',
  checkFailed: 'Check failed ({{status}})',
  saveFailed: 'Could not save ({{status}})',
  exportFailed: 'Export failed ({{status}})',
};

const ko = {
  title: '마지막 확인 이후 변경 사항',
  comparing: '현재 {{noun}}({{now}}행)를 <b>{{at}}</b>에 확인 완료로 표시한 {{noun}}({{then}}행)와 비교하고 있습니다',
  intro: '새로 생긴 행, 사라진 행, 값이 바뀐 셀을 모두 보여 주며, 이전 값과 새 값을 나란히 표시합니다',
  close: '닫기',
  firstTitle: '첫 번째 확인입니다',
  firstBody: '아직 비교할 기준이 없습니다. 현재 상태의 {{noun}}({{n}}행)를 시작점으로 저장하세요 — 그 이후로 변경 사항 확인은 그 시점 이후 바뀐 모든 것을, 누가 또는 무엇이 바꿨든 보여 줍니다.',
  chipChanged: '변경',
  chipNew: '신규',
  chipGone: '삭제',
  rows_one: '{{n}}행',
  rows_other: '{{n}}행',
  wordChanged: '변경',
  wordAdded: '새 행',
  wordRemoved: '사라진 행',
  nothingChanged: '{{at}} 이후 {{noun}}에서 바뀐 것이 없습니다.',
  cellsByColumn: '열별 변경 셀:',
  searchAria: '변경 사항 검색',
  clear: '지우기',
  countOf: '{{total}}행 중 {{shown}}행',
  truncated: '목록에는 변경된 {{total}}행 중 처음 {{shown}}행만 표시됩니다. Excel 내보내기에는 모두 포함됩니다.',
  colChange: '변경',
  colWhat: '변경 내용',
  colWhere: '출처',
  showMore: '{{n}}개 더 보기',
  compareWith: '비교 기준',
  myLastCheck: '마지막 확인 — {{at}}',
  earlierCheck: '이전 확인 — {{at}}',
  checkAgain: '다시 확인',
  building: '생성 중…',
  exportExcel: 'Excel 내보내기',
  markHint: '지금 보이는 상태가 다음 확인의 시작점이 됩니다',
  marked: '확인 완료로 표시됨',
  mark: '확인 완료로 표시',
  savedShort: '저장됨',
  saveStart: '시작점으로 저장',
  savedNext: '저장했습니다. 다음 확인은 {{at}} 시점의 {{noun}}와 비교합니다.',
  checkFailed: '확인 실패 ({{status}})',
  saveFailed: '저장할 수 없습니다 ({{status}})',
  exportFailed: '내보내기 실패 ({{status}})',
};

const vi = {
  title: 'Thay đổi kể từ lần kiểm tra trước',
  comparing: 'Đang so sánh {{noun}} hiện tại ({{now}} dòng) với {{noun}} bạn đã đánh dấu đã kiểm tra lúc <b>{{at}}</b> ({{then}} dòng)',
  intro: 'Mọi dòng mới, mọi dòng đã mất và mọi ô đã thay đổi, giá trị cũ cạnh giá trị mới',
  close: 'Đóng',
  firstTitle: 'Đây là lần kiểm tra đầu tiên của bạn',
  firstBody: 'Chưa có gì để so sánh. Hãy lưu {{noun}} như hiện tại ({{n}} dòng) làm mốc bắt đầu — từ đó trở đi, Kiểm tra thay đổi sẽ liệt kê mọi thứ thay đổi sau mốc này, dù do ai hay do đâu.',
  chipChanged: 'Đã đổi',
  chipNew: 'Mới',
  chipGone: 'Đã mất',
  rows_one: '{{n}} dòng',
  rows_other: '{{n}} dòng',
  wordChanged: 'Đã đổi',
  wordAdded: 'Dòng mới',
  wordRemoved: 'Dòng đã mất',
  nothingChanged: 'Không có gì trên {{noun}} thay đổi kể từ {{at}}.',
  cellsByColumn: 'Số ô thay đổi theo cột:',
  searchAria: 'Tìm trong các thay đổi',
  clear: 'Bỏ lọc',
  countOf: '{{shown}} / {{total}} dòng',
  truncated: 'Danh sách hiển thị {{shown}} dòng đầu trong {{total}} dòng thay đổi. File Xuất Excel có đủ tất cả.',
  colChange: 'Thay đổi',
  colWhat: 'Nội dung thay đổi',
  colWhere: 'Nguồn',
  showMore: 'Hiện thêm {{n}}',
  compareWith: 'So sánh với',
  myLastCheck: 'lần kiểm tra gần nhất — {{at}}',
  earlierCheck: 'một lần kiểm tra trước đó — {{at}}',
  checkAgain: 'Kiểm tra lại',
  building: 'Đang tạo…',
  exportExcel: 'Xuất Excel',
  markHint: 'Những gì bạn đang thấy sẽ là mốc bắt đầu cho lần kiểm tra sau',
  marked: 'Đã đánh dấu đã kiểm tra',
  mark: 'Đánh dấu đã kiểm tra',
  savedShort: 'Đã lưu',
  saveStart: 'Lưu làm mốc bắt đầu',
  savedNext: 'Đã lưu. Lần kiểm tra sau sẽ so sánh với {{noun}} tại thời điểm {{at}}.',
  checkFailed: 'Kiểm tra thất bại ({{status}})',
  saveFailed: 'Không lưu được ({{status}})',
  exportFailed: 'Xuất file thất bại ({{status}})',
};

const zh = {
  title: '自上次核对以来的变更',
  comparing: '正在将当前{{noun}}（{{now}} 行）与您于 <b>{{at}}</b> 标记为已核对的{{noun}}（{{then}} 行）进行比较',
  intro: '所有新增的行、消失的行以及变动的单元格，新旧值并列显示',
  close: '关闭',
  firstTitle: '这是您的第一次核对',
  firstBody: '目前还没有可比较的基准。请将当前的{{noun}}（{{n}} 行）保存为起点——此后，“检查变更”会列出在此之后发生的所有变动，无论由谁或由何引起。',
  chipChanged: '已变更',
  chipNew: '新增',
  chipGone: '已消失',
  rows_one: '{{n}} 行',
  rows_other: '{{n}} 行',
  wordChanged: '已变更',
  wordAdded: '新增行',
  wordRemoved: '行已消失',
  nothingChanged: '自 {{at}} 以来，{{noun}}上没有任何变更。',
  cellsByColumn: '按列统计的变更单元格：',
  searchAria: '搜索变更',
  clear: '清除',
  countOf: '{{shown}} / {{total}} 行',
  truncated: '列表仅显示 {{total}} 个变更行中的前 {{shown}} 行。导出 Excel 包含全部。',
  colChange: '变更',
  colWhat: '变更内容',
  colWhere: '来源',
  showMore: '再显示 {{n}} 行',
  compareWith: '比较对象',
  myLastCheck: '我的上次核对 — {{at}}',
  earlierCheck: '更早的一次核对 — {{at}}',
  checkAgain: '重新检查',
  building: '生成中…',
  exportExcel: '导出 Excel',
  markHint: '您现在看到的内容将成为下次核对的起点',
  marked: '已标记为已核对',
  mark: '标记为已核对',
  savedShort: '已保存',
  saveStart: '保存为我的起点',
  savedNext: '已保存。下次核对将与 {{at}} 时的{{noun}}进行比较。',
  checkFailed: '检查失败（{{status}}）',
  saveFailed: '无法保存（{{status}}）',
  exportFailed: '导出失败（{{status}}）',
};

// French and Japanese (task #1173, 2026-11-04) — generated from `en`; a string not yet translated reads English.
const fr = {
  "title": "Modifications depuis votre dernier contrôle",
  "comparing": "Comparaison : {{noun}} actuel ({{now}} lignes) et {{noun}} marqué comme vérifié le <b>{{at}}</b> ({{then}} lignes)",
  "intro": "Chaque nouvelle ligne, chaque ligne disparue et chaque cellule modifiée, ancienne valeur à côté de la nouvelle",
  "close": "Fermer",
  "firstTitle": "Ceci est votre premier contrôle",
  "firstBody": "Il n'y a encore rien à comparer. Enregistrez {{noun}} tel qu'il est maintenant ({{n}} lignes) comme point de départ — ensuite, Check changes liste tout ce qui a bougé depuis, quelle que soit la personne ou la tâche à l'origine du changement.",
  "chipChanged": "Modifiées",
  "chipNew": "Nouvelles",
  "chipGone": "Disparues",
  "rows_one": "{{n}} ligne",
  "rows_other": "{{n}} lignes",
  "wordChanged": "Modifié",
  "wordAdded": "Nouvelle ligne",
  "wordRemoved": "Ligne disparue",
  "nothingChanged": "Rien n'a changé dans {{noun}} depuis le {{at}}.",
  "cellsByColumn": "Cellules modifiées par colonne :",
  "searchAria": "Rechercher dans les modifications",
  "clear": "Effacer",
  "countOf": "{{shown}} lignes sur {{total}}",
  "truncated": "La liste affiche les {{shown}} premières des {{total}} lignes modifiées. Export Excel les contient toutes.",
  "colChange": "Modification",
  "colWhat": "Ce qui a changé",
  "colWhere": "Origine",
  "showMore": "Afficher {{n}} de plus",
  "compareWith": "Comparer avec",
  "myLastCheck": "mon dernier contrôle — {{at}}",
  "earlierCheck": "un contrôle antérieur — {{at}}",
  "checkAgain": "Contrôler à nouveau",
  "building": "Construction…",
  "exportExcel": "Exporter Excel",
  "markHint": "Ce que vous voyez maintenant devient votre point de départ pour le prochain contrôle",
  "marked": "Marqué comme vérifié",
  "mark": "Marquer comme vérifié",
  "savedShort": "Enregistré",
  "saveStart": "Enregistrer comme mon point de départ",
  "savedNext": "Enregistré. Votre prochain contrôle comparera avec {{noun}} au {{at}}.",
  "checkFailed": "Échec du contrôle ({{status}})",
  "saveFailed": "Impossible d'enregistrer ({{status}})",
  "exportFailed": "Échec de l'export ({{status}})"
};
const ja = {
  "title": "前回の確認以降の変更",
  "comparing": "現在の{{noun}}（{{now}} 行）と、<b>{{at}}</b> に確認済みとした{{noun}}（{{then}} 行）を比較しています",
  "intro": "新しい行、削除された行、変更されたすべてのセルを、旧値と新値を並べて表示します",
  "close": "閉じる",
  "firstTitle": "今回が最初の確認です",
  "firstBody": "比較対象がまだありません。現在の{{noun}}（{{n}} 行）を起点として保存してください。以降は、変更確認（Check changes）で、誰が、何が変更したかにかかわらず、その後に変更されたすべてを一覧表示します。",
  "chipChanged": "変更",
  "chipNew": "新規",
  "chipGone": "削除",
  "rows_one": "{{n}} 行",
  "rows_other": "{{n}} 行",
  "wordChanged": "変更",
  "wordAdded": "新しい行",
  "wordRemoved": "行を削除",
  "nothingChanged": "{{at}} 以降、{{noun}}に変更はありません。",
  "cellsByColumn": "列ごとの変更セル数：",
  "searchAria": "変更を検索",
  "clear": "クリア",
  "countOf": "{{total}} 行中 {{shown}} 行",
  "truncated": "一覧には、変更された {{total}} 行のうち最初の {{shown}} 行を表示しています。すべての行は Export Excel に含まれます。",
  "colChange": "変更",
  "colWhat": "変更内容",
  "colWhere": "変更元",
  "showMore": "さらに {{n}} 件を表示",
  "compareWith": "比較対象",
  "myLastCheck": "前回の自分の確認 — {{at}}",
  "earlierCheck": "それ以前の確認 — {{at}}",
  "checkAgain": "再確認",
  "building": "作成中…",
  "exportExcel": "Excel をエクスポート",
  "markHint": "現在表示されている内容が、次回の確認の起点になります",
  "marked": "確認済みとして記録しました",
  "mark": "確認済みにする",
  "savedShort": "保存しました",
  "saveStart": "自分の起点として保存",
  "savedNext": "保存しました。次回の確認では、{{at}} 時点の{{noun}}と比較します。",
  "checkFailed": "確認に失敗しました（{{status}}）",
  "saveFailed": "保存できませんでした（{{status}}）",
  "exportFailed": "エクスポートに失敗しました（{{status}}）"
};

const dictionary = { ns: 'xChange', en, ko, vi, zh, fr, ja };

export default dictionary;
